export function isValidFileSize(files) {
    // Define the maximum file size limit in bytes (100MB)
    const maxFileSize = 100 * 1024 * 1024; // 100MB in bytes

    // Initialize an array to store the names of files exceeding the size limit
    const oversizedFiles = [];

    // Iterate through the files array
    for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Check if the file size exceeds the maximum limit
        if (file.size > maxFileSize) {
            // Add the name of the oversized file to the array
            oversizedFiles.push(file.name);
        }
    }

    // Check if there are any oversized files
    if (oversizedFiles.length > 0) {
        // Render a single error message with the list of oversized files
        return `Max file size limit is 100MB. <br>Consider uploading it to Google Drive, Dropbox or OneDrive instead and add a link in the description.`;
    } else {
        return false;
    }
}